import { useEffect, useRef, useState } from 'react';

const CHECK_INTERVAL = 60_000; // Check every 60 seconds

export function useVersionCheck() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const initialHash = useRef<string | null>(null);

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const res = await fetch('/version.json?t=' + Date.now());
        if (!res.ok) return null;
        const data = await res.json();
        return data.hash as string;
      } catch {
        return null;
      }
    };

    // Set initial hash
    fetchVersion().then(hash => {
      if (hash) initialHash.current = hash;
    });

    // Poll for changes
    const interval = setInterval(async () => {
      const hash = await fetchVersion();
      if (hash && initialHash.current && hash !== initialHash.current) {
        setUpdateAvailable(true);
        clearInterval(interval); // Stop polling once update detected
      }
    }, CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  return { updateAvailable };
}
